<template>
  <workLink
    :data-hover="work.hasPage || !work.type ? 'link' : ''"
    :data-negative="work.indexColor === 'black' ? true : false"
    :link="work.type ? goTo() : {name: work.slug === 'cosa' ? 'cosa' : 'page', params: {page: work.slug}}"
    :isLink="work.hasPage || !work.type"
    class="work cell"
    :class="[{
      'large-6 xlarge-3' : !work.cols || work.cols === 1,
      'large-6' : work.cols === 2,
      'large-9' : work.cols === 3,
      'large-12' : work.cols === 4,
      }, work.indexColor, work.indexType]"
    v-if="work.indexType === 'text'"
  >
    <p class="cat" v-if="work.type">{{$t('filters.' + work.type)}}</p>
    <p class="title h1">{{work.abstract}}</p>
    <p class="h5 desc">{{work.description}}</p>
    <p v-if="work.hasPage || !work.type" class="readmore h5">
      <span class="fake-link">{{$t('message.read')}}</span>
    </p>
  </workLink>

  <workLink
    :link="work.type ? goTo() : {name: 'page', params: {page: work.slug}}"
    :isLink="work.hasPage || !work.type"
    v-else-if="work.indexType === 'image'"
    class="work cell"
    :class="[{
      'large-6 xlarge-3' : !work.cols || work.cols === 1,
      'large-6' : work.cols === 2,
      'large-9' : work.cols === 3 || work.cols === 4,
      }, work.indexType]"
  >
    <!-- <div
      :style="{'background-image' : 'url(' + resourceUrl + work.mainImage.file.path + ')'}"
      class="background show-for-large"
    ></div>-->
    <img
      class="background show-for-large"
      v-if="work.mainImage && work.mainImage.file"
      :src="resourceUrl + work.mainImage.file.path"
    />
    <div
      class="wrapper grid-x align-bottom"
      :data-hover="work.hasPage || !work.type ? 'link' : ''"
      :data-negative="true"
    >
      <div class="inner cell">
        <img
          class="hide-for-large mobile-image"
          v-if="(work.mobileImage && work.mobileImage.file) || (work.mainImage && work.mainImage.file)"
          :src="resourceUrl + (work.mobileImage && work.mobileImage.file ? work.mobileImage.file.path : work.mainImage.file.path)"
        />
        <p v-if="work.type" class="cat">{{$t('filters.' + work.type)}}</p>
        <p class="title h1">{{work.abstract}}</p>
        <p class="h5 desc">{{work.description}}</p>
        <p v-if="work.hasPage || !work.type" class="readmore h5">
          <span class="fake-link">{{$t('message.read')}}</span>
        </p>
      </div>
    </div>
  </workLink>
</template>
<script>
import workLink from "@components/workLink";

export default {
  components: {
    workLink
  },
  props: {
    work: {
      default: {}
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  },
  methods: {
    goTo() {
      return `/${this.$i18n.locale}/${this.$t("nav.cosa.slug")}/${
        this.work.slug
      }`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.work {
  overflow: hidden;
  margin-bottom: 32px;
  cursor: pointer;
  &:hover {
    a {
      text-decoration: none !important;
    }
  }
}
.work.text {
  background: $white;
  padding: 64px 32px;
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
    &.cat {
      // text-transform: capitalize;
      font-weight: $global-weight-bold;
    }
    &.title {
      font-weight: $global-weight-bold;
      margin-bottom: 16px;
    }
    &.desc {
      font-weight: $global-weight-light;
      line-height: 26px;
    }
    &.readmore {
      text-align: right;
      font-weight: $global-weight-bold;
      .fake-link {
        text-decoration: underline;
      }
    }
  }
  &.black {
    background: $black;
    color: $white;
    a {
      color: $white;
    }
  }
}
.work.image {
  position: relative;
  z-index: 1;
  @include breakpoint(medium down) {
    background: $black;
  }
  // .background {
  //   z-index: -1;
  //   background-size: cover;
  //   -webkit-background-size: cover;
  //   background-position: center;
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   height: 100%;
  //   width: 100%;
  // }
  // &::after {
  //   content: "";
  //   z-index: -1;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 0;
  //   height: 100%;
  //   background: $black;
  //   @include transition-duration(0.4s);
  //   @include breakpoint(medium down) {
  //     display: none;
  //   }
  // }
  z-index: 1;
  .background {
    z-index: -1;
    width: 100%;
    pointer-events: none;
  }
  &::after {
    content: "";
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background: $black;
    @include transition-duration(0.4s);
    @include breakpoint(medium down) {
      display: none;
    }
  }
  .wrapper {
    z-index: 2;
    pointer-events: none;
    position: relative;
    @include transition-duration(0.4s);
    @include breakpoint(large up) {
      opacity: 0;
      bottom: -64px;
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .inner {
      width: 100%;
      display: inline-block;
      padding: 64px 32px;
      z-index: 2;
      @include breakpoint(medium down) {
        padding: 0 32px 64px;
      }
      .mobile-image {
        margin-bottom: 64px;
        margin-left: -32px;
        width: calc(100% + 64px);
        max-width: calc(100% + 64px);
      }
      p {
        color: $white;
        margin-bottom: 32px;
        &:last-of-type {
          margin-bottom: 0;
        }
        &.cat {
          text-transform: capitalize;
          font-weight: $global-weight-bold;
        }
        &.title {
          margin-bottom: 16px;
        }
        &.desc {
          font-weight: $global-weight-light;
          line-height: 26px;
        }
        &.readmore {
          text-align: right;
          font-weight: $global-weight-bold;
          a {
            text-decoration: underline;
            color: $white;
          }
        }
      }
    }
  }
  &:hover {
    &::after {
      width: 100%;
    }
    .wrapper {
      pointer-events: all;
      opacity: 1;
      bottom: 0;
    }
  }
  &.large-3 {
    .wrapper {
      @include breakpoint(large up) {
        min-height: 420px;
      }
    }
  }
  &.large-6 {
    .wrapper {
      @include breakpoint(large up) {
        min-height: 495px;
      }
    }
  }
  &.large-9 {
    .wrapper {
      @include breakpoint(large up) {
        min-height: 750px;
      }
      .inner {
        @include breakpoint(large up) {
          width: calc((100vw - 128px) / 2 - 16px);
        }
        // .mobile-image {
        //   margin-left: -32px;
        //   width: calc(100% + 64px);
        //   max-width: calc(100% + 64px);
        // }
      }
    }
    &:hover::after {
      @include breakpoint(large up) {
        width: calc((100vw - 128px) / 2 - 16px);
      }
    }
  }
}
</style>